export default __webpack_public_path__ + "static/media/Landing_Journey.15cf2eb8.png";